// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2944v","signatureBlock":"Footer_signatureBlock__2KmNf","signature":"Footer_signature__XA3fH"};